import React, { useMemo } from 'react';
import classnames from 'classnames';
import lessModule from './score-number.module.less';

export interface IScoreNumberProps {
  value: number;
  className?: string;
}

export const ScoreNumber = React.memo(({ className, value }: IScoreNumberProps) => {

  const computedValue = useMemo(() => {
    const target = Number(value);
    const isNan = isNaN(target);
    if (isNan) {
      return 0.0;
    } else {
      return target;
    }
  }, [value]);

  const computedClass = useMemo(() => {
    if (computedValue <= 5) return lessModule.number3;
    if (computedValue > 5 && computedValue <= 6) return lessModule.number2;
    if (computedValue > 6 && computedValue <= 9) return lessModule.number1;
  }, [computedValue]);


  return <div className={classnames(lessModule.number, computedClass, className)}>{computedValue.toFixed(1)}</div>;
});
